import React from "react";

import { Box, CssBaseline } from "@mui/material";

import Audiograms from "../modules/Audiograms";

function AudiogramsPage() {
  return (
    <Box sx={{ display: "flex" }}>
      <CssBaseline />
      <Audiograms />
    </Box>
  );
}

export default AudiogramsPage;
